import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import WebsiteLayoutWS from '../WebsiteLayoutWS';
import FeatureElement from '../components/FeatureElement';
import CallToAction from '../components/CallToAction';
import HeaderPage from '../components/HeaderPage';

const PricingWs = ({ businessData }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const theme = useTheme();
  const tableRef = useRef(null);

  useEffect(() => {
    if (!document.querySelector('script[src="https://js.stripe.com/v3/pricing-table.js"]')) {
      const script = document.createElement('script');
      script.src = 'https://js.stripe.com/v3/pricing-table.js';
      script.async = true;
      document.body.appendChild(script);
    }

    const timeout = setTimeout(() => {
      if (tableRef.current) {
        tableRef.current.innerHTML = `
       <stripe-pricing-table pricing-table-id="prctbl_1RNaR4039uUr8lBdCay9bhpC"
publishable-key="pk_live_51PpVVc039uUr8lBdyHrPXPgJbBDldnuBHEMqvbu3I0q05aWx5lQQrVpUEuo3qGEtWcSjx3TFkjdDHr0RYOKbn0fZ0029TBJ0u4">
</stripe-pricing-table>
        `;
      }
    }, 500);

    return () => clearTimeout(timeout);
  }, []);

  return (
    <WebsiteLayoutWS>
      <Helmet>
        <title>CHEK UP - {t('pricing')}</title>
        <meta
          name="description"
          content="CHEK offre une plateforme intuitive aux réparateurs automobiles pour gérer efficacement les rendez-vous, les devis, les factures et les pièces, le tout en un seul endroit facile à utiliser."
        />
      </Helmet>

      <HeaderPage
        title="Tarification"
        subtitle="Une plateforme puissante, un prix clair."
        caption="Aucun frais par utilisateur. Des outils flexibles, adaptés à toutes les tailles d'atelier."
      />

      <div className="mt-5 mb-2" style={{ width: '100%' }}>
        <div style={{ paddingBottom: '30px' }} ref={tableRef} />
      </div>

      <CallToAction
        title="Prêt à transformer votre atelier d'automobile?"
        description="CHEK offre une solution complète pour les ateliers automobiles qui souhaitent se moderniser. Obtenez une démonstration gratuite et découvrez comment vous pouvez augmenter votre productivité."
        primaryButtonText="Demandez votre démo gratuite maintenant !"
        primaryButtonLink="/onboard"
        secondaryButtonText="Voir la vidéo de démonstration"
        secondaryButtonLink="/demo"
      />
    </WebsiteLayoutWS >
  );
};

export default PricingWs;
